import React, { useState, useCallback } from 'react';
import { Location } from './types';
import { REGIONS } from './data/scenes';
import { SceneGrid } from './components/SceneGrid';
import { ScenePlayer } from './components/ScenePlayer';
import { useAudioEngine } from './hooks/useAudioEngine';
import './App.css';

function App() {
  const [selectedLocation, setSelectedLocation] = useState<Location | null>(null);
  const audioEngine = useAudioEngine();

  const handleSelectLocation = useCallback((location: Location) => {
    setSelectedLocation(location);
  }, []);

  const handleBack = useCallback(() => {
    audioEngine.stopAll();
    setSelectedLocation(null);
  }, [audioEngine]);

  return (
    <div className="app">
      {selectedLocation ? (
        <ScenePlayer
          location={selectedLocation}
          audioEngine={audioEngine}
          onBack={handleBack}
        />
      ) : (
        <SceneGrid regions={REGIONS} onSelectLocation={handleSelectLocation} />
      )}
    </div>
  );
}

export default App;
